import { render } from "./BarcodeSide.vue?vue&type=template&id=12db9fa9"
import script from "./BarcodeSide.vue?vue&type=script&lang=js"
export * from "./BarcodeSide.vue?vue&type=script&lang=js"

import exportComponent from "D:\\01. Workspace\\orot_kiosk\\src\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__